module.exports = __webpack_public_path__ + "img/IchHabeEineBanane.0657eff9.jpg";